import { useSite } from '@/store'
import { useStore } from 'vuex'
import $ from 'jquery'
import { t } from '@/plugins/i18n'
import { echatConfig } from '@/common/echatKey'
export default () => {
  const config = echatConfig()
  const language = useSite()
  const store = useStore()
  const user = store.getters.user

  const xmlInfo='<xml>' +
  '<uid><![CDATA[' + user?.customerId + ']]></uid>' +
  '<vip><![CDATA[' + (user?.membership?.templateLevel > 0 ? 1 : 2) + ']]></vip>' +
  '<category><![CDATA[' + user?.membership?.membershipTemplateName + ']]></category>' +
  '<name><![CDATA[' + user?.loginName + ']]></name>' +
  '<email><![CDATA[' + user?.customerEmail + ']]></email>' +
  '</xml>'

  const metaData = store.getters.isLogin ? window.WECHAT.wxEncrypt(xmlInfo, config.key, config.appid).toString() : ''
  return {
    language,
    metaData,
    companyId: config.companyId
  }
}

/**
 *
 * @param {
*   target: HTMLElement
*   width: number | defautl=510
*   height: number | default = 790
*   url:string
*   close:boolean
*   type:'create' | 'preview'
*   orderId:string
*
* } config
*/

interface CreateOrderChatConfig {
  target: HTMLElement
  width?: number
  height?: number
  url: string
  imgUrl: string
  close?: boolean
  type: 'create' | 'preview'
  orderId: string
  title?:string
}

export interface VisitorTicketListResultItem {
  lastType: number;
  myData: string;
  ticketContent: string;
  ticketId: number;
  ticketStatus: number;
  ticketTime: string;
  ticketTitle: string;
  ticketUrl: string;
  unRead: number;
}
export interface getVisitorTicketListResult {
  result: VisitorTicketListResultItem[]
  successful: boolean
}

export class CreateOrderChat {
 config: CreateOrderChatConfig
 constructor (config: CreateOrderChatConfig) {
   this.config = config;
   this.init();
 }

 init () {
   // 判断是否已存在弹窗，存在删除
   if ($('.cs-modal').length) {
     $('.cs-modal').remove();
   }

   const {
     target,
     width = 510,
     height = 790,
     url,
     close = false,
     imgUrl,
     type,
     orderId,
     title
   } = this.config;

   const targetStyle = target.getBoundingClientRect();
   const positionLeft = targetStyle.left - width - 20;
   const top = (window.innerHeight - targetStyle.top) / 2;
   console.log('开始');
   // 根据弹窗的类型，设置弹窗顶部的内容
   let topElement = '';
   if (type === 'create') {
     topElement = `<div class="create-top">
        <div class="create-top-title">
          <span>${title}：${orderId}</span>
        </div>
         <div class="cs-modal-close">
            <img src="${imgUrl}" alt="" style="width:16px">
         </div>
      </div>`;
   } else {
     topElement = `<div class="preview-top">
        <div class="create-top-title">
          <span>${title}：${orderId}</span>
        </div>
         <div class="cs-modal-close">
            <img src="${imgUrl}" alt="" style="width:16px">
         </div>
      </div>`;
   }

   const modal = `
       <div class="cs-modal" style="width:${width}px;height:${height}px;">
         ${topElement}
         <iframe src="${url}" width="${width}" height="${
     type === 'preview' ? height - 50 : height
   }'}" frameborder="0" scrolling="no"></iframe>
       </div>
     `;

   $('body').append(modal);

   $('.cs-modal').css({
     position: 'fixed',
     left: positionLeft,
     top: '60px',
     zIndex: 9999
   });

   function closeCustomModal (e:any) {
     if (!e.target.classList.contains('cs-modal')) {
       $('.cs-modal').remove()
     }
   }

   // 如果close为true，则添加body点击事件，关闭弹窗
   if (close) {
     document.body.removeEventListener('click', closeCustomModal, false);
     document.body.addEventListener('click', closeCustomModal, false);
   }

   // 关闭弹窗
   $('.cs-modal-close').click(function (e: { stopPropagation: () => void }) {
     e.stopPropagation();
     $('.cs-modal').remove();
   })
 }
}
